// import axios from 'axios'
import { post, put, get, remove, patch } from '@/api/api'

export const actions = {
  async fetchFluxPage({commit}, params = {}) {
    const { page = 0, size = 10, sort = ''} = params;
    const queryParams = new URLSearchParams({
      page,
      size,
      sort, 
    }).toString();

    let { data } = await get(`/canal/flux/paiement/page?${queryParams}`);
    commit("addFluxPage", data)
    return data;
  },
  fetchFluxByUser ({ commit}, userId) {
    return get(`/canal/flux/paiement/user${userId}`)
      .then(({ data }) => {})
  },
  createEcran ({ commit }, ecran) {
    return post('/canal/screen', ecran)
      .then(({ data }) => {
        commit('addEcran', data)
      })
  },
  updateFlux ({ commit }, flux) {
    return put(`/canal/flux/paiement/${flux.id}`, flux)
      .then(({ data }) => {
        commit('replaceFlux', data)
      })
  },
  createOrUpdateEcran ({ dispatch }, ecran) {
    if (ecran.id !== undefined) {
      return dispatch('updateEcran', ecran)
    } else {
      return dispatch('createEcran', ecran)
    }
  },
  deleteEcran ({ commit}, ecran) {
    // const { pageNumber = 0, pageSize = state.pagination.size } = params
    return remove(`/canal/screen/${ecran.id}`)
      .then(({ data }) => {
        
      })
  },
  selectecran ({ commit }, ecran) {
    commit('setEcran', ecran)
  }
}
